import React from "react";
import { Business } from "../components";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
// import { AppleButton } from "../components";

export function BusinessContainer({ children }) {
  return (
    <Business>
      <Business.Heading>
        Keep visitor count via a central analytics dashboard
      </Business.Heading>
      <Business.Line />
      <Business.Pane>
        <Business.ImageSwiper>
          <Business.SubHeading>
            We work systematically to integrate corporate responsibility in our
            core business and make our expertise available for the benefit of
            the societies where we operate.
          </Business.SubHeading>
          <Carousel autoPlay="true" infiniteLoop="true">
            <div>
              <img
                alt="abc"
                src="/images/vmsphotos/img1.png"
                style={{
                  height: "400px",
                  width: "100%",
                  objectFit: "cover",
                  objectPosition: "center 0px",
                }}
              />
            </div>
            <div>
              <img
                alt="abc"
                src="/images/vmsphotos/img2.png"
                style={{
                  height: "400px",
                  width: "100%",
                  objectFit: "cover",
                  objectPosition: "center 0px",
                }}
              />
            </div>
            <div>
              <img
                alt="abc"
                src="/images/vmsphotos/img3.png"
                style={{
                  height: "400px",
                  width: "100%",
                  objectFit: "cover",
                  objectPosition: "center 0px",
                }}
              />
            </div>
            <div>
              <img
                alt="abc"
                src="/images/vmsphotos/img4.png"
                style={{
                  height: "400px",
                  width: "100%",
                  objectFit: "cover",
                  objectPosition: "center 0px",
                }}
              />
            </div>
          </Carousel>
        </Business.ImageSwiper>
        <Business.InfoContainer>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>Smart SaaS Platform </Business.SubHeading>
          </Business.Content>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>
              Capture and Monitor live traffic
            </Business.SubHeading>
          </Business.Content>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>
              Analytics using Data Patterns
            </Business.SubHeading>
          </Business.Content>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>Live Monitoring Dashboard</Business.SubHeading>
          </Business.Content>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>Display Busy Access Times</Business.SubHeading>
          </Business.Content>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>
              Google like Search Feature
            </Business.SubHeading>
          </Business.Content>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>Automated Backup Module</Business.SubHeading>
          </Business.Content>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>
              Reporting with CSV, PDF, XLS
            </Business.SubHeading>
          </Business.Content>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>
              Admin & Concierge Level Access
            </Business.SubHeading>
          </Business.Content>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>
              Application Hosted at OOREDOO Cloud, Qatar
            </Business.SubHeading>
          </Business.Content>
          <Business.Content>
            <Business.Icon />
            <Business.SubHeading>
              App and iPad Stand Copyright from Ministry of Commerce & Industry
              Qatar{" "}
            </Business.SubHeading>
          </Business.Content>
          {/* <Business.Button
            onClick={() => {
              window.location.assign(
                "https://apps.apple.com/us/app/vms-manage-visitors/id1493484227/"
              );
            }}
          >
            <Business.ButtonContainer>
              <Business.ButtonDiv>
                <img src="/images/icons/_Group_.png" alt="abc" />
              </Business.ButtonDiv>
              <div>
                <Business.ButtonHead> Download on the </Business.ButtonHead>
                <Business.ButtonBase>App Store</Business.ButtonBase>
              </div>
            </Business.ButtonContainer>
          </Business.Button> */}
        </Business.InfoContainer>
      </Business.Pane>
      {children}
    </Business>
  );
}
